import { Actions, LocationState } from "@/components/framework/locationswitcher/locationReducer";
import { ActionDispatch } from "react";
import styles from "./SelectedLocations.module.css";
import LocationButton from "@/components/framework/locationswitcher/LocationButton";

//#region [Props]
type SelectedLocationsProps = {
    selectedLocations: LocationState;
    dispatch: ActionDispatch<[action: Actions]>;
};
//#endregion

//#region [Component]
export default function SelectedLocations({ selectedLocations, dispatch }: SelectedLocationsProps) {
    return <div className={styles.LocationListContainer}>
        <div className={styles.LocationList}>
            <h2 className={styles.Label}>Mine valgte bygdekinoer:</h2>
            {selectedLocations.selected.map(loc => <LocationButton key={loc.teaternr} onClick={() => dispatch({ type: "removeLocation", value: loc })} location={loc} />)}
            {selectedLocations.selected.length === 0 && <>Ingen valgte</>}
        </div>
        <div className={styles.HelperText}>Klikk på kryss for å fjerne en bygdekino og bruk søkefeltet/fylkesliste til å legge til</div>
    </div>;
}
//#endregion

//#region [Styles]

//#endregion
